import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
const DataGridCustom = ({
  classes,
  styles,
  columns,
  rows,
  viewProfile,
  handleRowEditClick,
  handleRowDeleteClick,
}) => {
  return (
    <DataGrid
      className={classes.gridRoot}
      pageSize={styles.gridConfig.pageSize}
      rowHeight={styles.gridConfig.rowHeight}
      headerHeight={styles.gridConfig.headerHeight}
      autoHeight={styles.gridConfig.autoHeight}
      rows={rows}
      columns={[
        ...columns,
        ...(!viewProfile
          ? [
              {
                field: "actions",
                type: "actions",
                headerName: "",
                width: 120,
                getActions: ({ id }) => {
                  return [
                    <div title="Edit">
                      <EditIcon
                        className={classes.gridActionButton}
                        onClick={() => {
                          handleRowEditClick(id);
                        }}
                      />
                    </div>,
                    <div title="Delete">
                      <DeleteIcon
                        sx={{
                          marginLeft: "5px",
                        }}
                        className={classes.gridActionButton}
                        onClick={() => {
                          handleRowDeleteClick(id);
                        }}
                      />
                    </div>,
                  ];
                },
              },
            ]
          : []),
      ]}
      disableSelectionOnClick
      disableColumnSelector
      getCellClassName={(params) => {
        if (params.field !== "actions") {
          return styles.gridCellClassName;
        }
      }}
      components={{
        NoRowsOverlay: () => (
          <Box className={classes.noRowsOverlay}>No Rows</Box>
        ),
        NoResultsOverlay: () => (
          <Box className={classes.noRowsOverlay}>No Results Found</Box>
        ),
      }}
    />
  );
};
export default React.memo(DataGridCustom);
